module.exports = __webpack_public_path__ + "img/max-person-add.e196f273.svg";